import BaseSection from '@/sections/base'

export default class PageSection extends BaseSection {
  static TYPE = 'page'
}